module.exports = __webpack_public_path__ + "static/lato-regular-b4d2c4c39853ee244272c04999b230ba.woff2";